import { render, staticRenderFns } from "./purschemesimulation.vue?vue&type=template&id=70438b8e&scoped=true&"
import script from "./purschemesimulation.vue?vue&type=script&lang=js&"
export * from "./purschemesimulation.vue?vue&type=script&lang=js&"
import style0 from "./purschemesimulation.vue?vue&type=style&index=0&id=70438b8e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70438b8e",
  null
  
)

export default component.exports